import { PageLoading, PagePortableText } from '@bounty/creators-design-system'
import { useSWRSanity } from '../../hooks/swr'
import { createParam } from 'solito'

const { useParam } = createParam()

export function BlogDetailScreen() {
  const [slug] = useParam('slug')
  if (!slug) {
    throw new Error('Cannot find required param slug!')
  }
  const { data } = useSWRSanity('getBlog', slug)

  if (!data) {
    return <PageLoading />
  }

  return <PagePortableText item={data} />
}
